import type { TravelixFirebaseConfig } from "@travelix/core";

function required(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `[Travelix] Missing required env var ${key}. Copy .env.example → .env.local and fill it in.`,
    );
  }
  return value;
}

export const firebaseConfig: TravelixFirebaseConfig = {
  apiKey: required("VITE_FIREBASE_API_KEY"),
  authDomain: required("VITE_FIREBASE_AUTH_DOMAIN"),
  projectId: required("VITE_FIREBASE_PROJECT_ID"),
  storageBucket: required("VITE_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: required("VITE_FIREBASE_MESSAGING_SENDER_ID"),
  appId: required("VITE_FIREBASE_APP_ID"),
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
